import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppAbility } from "../../util/service/auth.service";
import { Observable } from "rxjs";
import { EntityTyp } from "../../util/enums/entity-typ.enum";
import { BaseFormGroupService } from "../../util/components/modal/base-form-group.service";
import { HousingDto } from "app/api/models";
import { HousingService } from "app/api/services";
import { CaslAction } from "app/server/enums/casl-action.enum";

@Injectable({
  providedIn: "root",
})
export class HousingFormGroupService extends BaseFormGroupService<HousingDto> {
  entitySingular = "Wohnung";

  constructor(
    private fb: FormBuilder,
    public override modal: NgbActiveModal,
    protected toastr: ToastrService,
    private housingService: HousingService,
    private ability: AppAbility
  ) {
    super(modal, toastr);
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      name: ["", [Validators.required]],
      address: ["", [Validators.required]],
      officeId: [null, Validators.required],
      version: [0, [Validators.required]],
    });

    this.setPermissions();
  }

  protected create(mergedEntity: HousingDto): Observable<HousingDto> {
    return this.housingService.housingControllerCreate({ body: mergedEntity });
  }

  protected update(mergedEntity: HousingDto): Observable<HousingDto> {
    return this.housingService.housingControllerUpdate({
      body: mergedEntity,
    });
  }

  protected reloadEntity(id: number): Observable<HousingDto> {
    return this.housingService.housingControllerFindOne({ id });
  }

  protected updateFormGroup(entity: HousingDto) {
    this.formGroup.patchValue(entity, { emitEvent: false });
    this.setPermissions();
  }

  private setPermissions() {
    if (this.ability.can(CaslAction.Update, EntityTyp.Housing)) {
      return;
    }
    this.formGroup.disable({ emitEvent: false });
  }
}
